import { render, staticRenderFns } from "./ApolicyDetails.vue?vue&type=template&id=9a16961e&scoped=true"
import script from "./ApolicyDetails.vue?vue&type=script&lang=js"
export * from "./ApolicyDetails.vue?vue&type=script&lang=js"
import style0 from "./ApolicyDetails.vue?vue&type=style&index=0&id=9a16961e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a16961e",
  null
  
)

export default component.exports